import { createFileRoute, getRouteApi } from '@tanstack/react-router';

import { ResultStructureDetails } from '@/components/result/ResultStructureDetails';
import { RoutePanel } from '@/components/routing/RoutePanel';
import { useRoutes } from '@/hooks/useRoutes';
import { TriasHelper } from '@/modules/TriasHelper';

export const Route = createFileRoute('/_map/_sidebar/route/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

const routeApi = getRouteApi('/_map');

function RouteComponent() {
  const { resultIndex } = routeApi.useSearch();
  const route = useRoutes();
  const resultStructures = TriasHelper.getIndividualRouteStructures(route.data);

  const hasDetail = typeof resultIndex === 'number' && !!resultStructures?.[resultIndex];

  if (hasDetail) {
    return <ResultStructureDetails resultStructure={resultStructures[resultIndex]} />;
  }

  return <RoutePanel />;
}
